export default {
  buttonHighlightPrimaryBgDefault: 'primarySolid500',
  buttonHighlightQuaternaryBgDefault: 'neutralWhiteTransparent0',
  buttonHighlightPrimaryBgPressed: 'primarySolid600',
  buttonHighlightPrimaryBgHover: 'primarySolid600',
  buttonHighlightPrimaryBgDisabled: 'primarySolid100',
  buttonHighlightQuaternaryLabelDefault: 'primarySolid500',
  buttonHighlightQuaternaryIconDefault: 'primarySolid500',
  buttonHighlightQuaternaryIconPressed: 'primarySolid500',
  buttonHighlightQuaternaryIconHover: 'primarySolid500',
  buttonHighlightQuaternaryIconDisabled: 'primarySolid200',
  buttonHighlightSecondaryBgDefault: 'primarySolid100',
  buttonHighlightSecondaryBgPressed: 'primarySolid200',
  buttonHighlightSecondaryBgHover: 'primarySolid200',
  buttonHighlightSecondaryBgDisabled: 'primarySolid100',
  buttonHighlightSecondaryLabelDefault: 'primarySolid600',
  buttonHighlightSecondaryLabelHover: 'primarySolid600',
  buttonHighlightSecondaryLabelPressed: 'primarySolid600',
  buttonHighlightSecondaryLabelDisabled: 'neutralBlackTransparent200',
  buttonHighlightSecondaryIconDefault: 'primarySolid600',
  buttonHighlightSecondaryIconPressed: 'primarySolid600',
  buttonHighlightSecondaryIconHover: 'primarySolid600',
  buttonHighlightSecondaryIconDisabled: 'neutralBlackTransparent200',
  buttonHighlightPrimaryLabelDefault: 'neutralSolid0',
  buttonHighlightPrimaryLabelHover: 'neutralSolid0',
  buttonHighlightPrimaryLabelPressed: 'neutralSolid0',
  buttonHighlightPrimaryLabelDisabled: 'neutralSolid0',
  buttonHighlightPrimaryIconDefault: 'neutralSolid0',
  buttonHighlightPrimaryIconPressed: 'neutralSolid0',
  buttonHighlightPrimaryIconHover: 'neutralSolid0',
  buttonHighlightPrimaryIconDisabled: 'neutralSolid0',
  buttonHighlightPrimaryStrokePressed: 'primarySolid500',
  buttonHighlightSecondaryStrokePressed: 'primarySolid500',
  buttonHighlightTerciaryLabelDefault: 'primarySolid500',
  buttonHighlightTerciaryLabelHover: 'primarySolid500',
  buttonHighlightTerciaryLabelPressed: 'primarySolid500',
  buttonHighlightTerciaryLabelDisabled: 'neutralBlackTransparent300',
  buttonHighlightTerciaryStrokePressed: 'primarySolid500',
  buttonHighlightTerciaryBgHover: 'primarySolid50',
  buttonHighlightTerciaryBgPressed: 'primarySolid50',
  buttonHighlightTerciaryIconDefault: 'primarySolid500',
  buttonHighlightTerciaryIconPressed: 'primarySolid500',
  buttonHighlightTerciaryIconHover: 'primarySolid500',
  buttonHighlightTerciaryIconDisabled: 'neutralBlackTransparent300',
  buttonHighlightTerciaryStrokeDefault: 'primarySolid200',
  buttonHighlightTerciaryStrokeHover: 'primarySolid200',
  buttonHighlightTerciaryStrokeDisabled: 'primarySolid100',
  tagBgDefault: 'neutralSolid300',
  tagBgHover: 'neutralSolid300',
  tagBgPressed: 'neutralSolid300',
  tagBgDisabled: 'neutralSolid300',
  tagStrokeFocus: 'primarySolid500',
  tagLabelDefault: 'neutralSolid900',
  tagLabelHover: 'neutralSolid900',
  tagLabelPressed: 'neutralSolid900',
  tagLabelDisabled: 'neutralSolid400',
  tagIconDefault: 'neutralSolid900',
  tagIconHover: 'neutralSolid900',
  tagIconPressed: 'neutralSolid900',
  tagIconDisabled: 'neutralSolid400',
  tagBgFocus: 'neutralSolid300',
  tagLabelFocus: 'neutralSolid900',
  tagIconFocus: 'neutralSolid900',
  buttonHighlightQuaternaryLabelHover: 'primarySolid500',
  buttonHighlightQuaternaryLabelPressed: 'primarySolid500',
  buttonHighlightQuaternaryLabelDisabled: 'primarySolid200',
  buttonHighlightQuaternaryStrokePressed: 'primarySolid500',
  buttonSubtlePrimaryBgDefault: 'secondarySolid500',
  buttonSubtlePrimaryIconDefault: 'neutralSolid0',
  buttonSubtlePrimaryIconPressed: 'neutralSolid0',
  buttonSubtlePrimaryIconHover: 'neutralSolid0',
  buttonSubtlePrimaryIconDisabled: 'neutralSolid0',
  buttonSubtlePrimaryLabelDefault: 'neutralSolid0',
  buttonSubtlePrimaryLabelHover: 'neutralSolid0',
  buttonSubtlePrimaryLabelPressed: 'neutralSolid0',
  buttonSubtlePrimaryLabelDisabled: 'neutralSolid0',
  buttonSubtlePrimaryBgHover: 'secondarySolid400',
  buttonSubtlePrimaryBgPressed: 'secondarySolid400',
  buttonSubtlePrimaryBgDisabled: 'secondarySolid50',
  buttonSubtleSecondaryBgDefault: 'secondarySolid100',
  buttonSubtleTerciaryBgHover: 'secondarySolid50',
  buttonSubtleTerciaryBgPressed: 'secondarySolid50',
  buttonSubtleTerciaryIconDefault: 'secondarySolid900',
  buttonSubtleTerciaryIconPressed: 'secondarySolid900',
  buttonSubtleTerciaryIconHover: 'secondarySolid900',
  buttonSubtleTerciaryIconDisabled: 'neutralSolid400',
  buttonSubtleTerciaryLabelDefault: 'secondarySolid900',
  buttonSubtleTerciaryLabelHover: 'secondarySolid900',
  buttonSubtleTerciaryLabelPressed: 'secondarySolid900',
  buttonSubtleTerciaryLabelDisabled: 'neutralSolid400',
  buttonSubtleTerciaryStrokeDefault: 'secondarySolid200',
  buttonSubtleTerciaryStrokeHover: 'secondarySolid200',
  buttonSubtleTerciaryStrokePressed: 'secondarySolid400',
  buttonSubtleTerciaryStrokeDisabled: 'secondarySolid100',
  buttonSubtleQuaternaryBgDefault: 'neutralWhiteTransparent0',
  buttonSubtleQuaternaryLabelDefault: 'secondarySolid400',
  buttonSubtleQuaternaryLabelHover: 'secondarySolid500',
  buttonSubtleQuaternaryLabelPressed: 'secondarySolid500',
  buttonSubtleQuaternaryLabelDisabled: 'secondarySolid100',
  buttonSubtleQuaternaryIconDefault: 'secondarySolid400',
  buttonSubtleQuaternaryStrokePressed: 'secondarySolid400',
  buttonSubtleQuaternaryIconHover: 'secondarySolid500',
  buttonSubtleQuaternaryIconPressed: 'secondarySolid500',
  buttonSubtleQuaternaryIconDisabled: 'secondarySolid100',
  buttonSubtleSecondaryIconDefault: 'secondarySolid900',
  buttonSubtleSecondaryIconPressed: 'secondarySolid900',
  buttonSubtleSecondaryIconHover: 'secondarySolid900',
  buttonSubtleSecondaryIconDisabled: 'neutralBlackTransparent200',
  buttonSubtleSecondaryLabelDefault: 'secondarySolid900',
  buttonSubtleSecondaryBgHover: 'secondarySolid200',
  buttonSubtleSecondaryStrokePressed: 'secondarySolid300',
  buttonSubtleSecondaryLabelHover: 'secondarySolid900',
  buttonSubtleSecondaryLabelPressed: 'secondarySolid900',
  buttonSubtleSecondaryLabelDisabled: 'neutralBlackTransparent200',
  buttonSubtleSecondaryBgPressed: 'secondarySolid200',
  buttonSubtleSecondaryBgDisabled: 'secondarySolid50',
  buttonSubtlePrimaryStrokePressed: 'secondarySolid300',
  buttonNegativePrimaryBgDefault: 'redSolid600',
  buttonNegativePrimaryIconDefault: 'neutralSolid0',
  buttonNegativePrimaryIconPressed: 'neutralSolid0',
  buttonNegativePrimaryIconHover: 'neutralSolid0',
  buttonNegativePrimaryIconDisabled: 'neutralSolid0',
  buttonNegativePrimaryLabelDefault: 'neutralSolid0',
  buttonNegativePrimaryLabelHover: 'neutralSolid0',
  buttonNegativePrimaryLabelPressed: 'neutralSolid0',
  buttonNegativePrimaryLabelDisabled: 'neutralSolid0',
  buttonNegativePrimaryBgHover: 'redSolid500',
  buttonNegativePrimaryBgPressed: 'redSolid500',
  buttonNegativePrimaryBgDisabled: 'redSolid100',
  buttonNegativeSecondaryBgDefault: 'redSolid50',
  buttonNegativeTerciaryBgHover: 'redSolid50',
  buttonNegativeTerciaryBgPressed: 'redSolid50',
  buttonNegativeTerciaryIconDefault: 'redSolid500',
  buttonNegativeTerciaryIconPressed: 'redSolid500',
  buttonNegativeTerciaryIconHover: 'redSolid500',
  buttonNegativeTerciaryIconDisabled: 'redSolid100',
  buttonNegativeTerciaryLabelDefault: 'redSolid500',
  buttonNegativeTerciaryLabelHover: 'redSolid500',
  buttonNegativeTerciaryLabelPressed: 'redSolid500',
  buttonNegativeTerciaryLabelDisabled: 'redSolid100',
  buttonNegativeTerciaryStrokeDefault: 'redSolid500',
  buttonNegativeTerciaryStrokeHover: 'redSolid500',
  buttonNegativeTerciaryStrokePressed: 'redSolid500',
  buttonNegativeTerciaryStrokeDisabled: 'redSolid100',
  buttonNegativeQuaternaryBgDefault: 'neutralWhiteTransparent0',
  buttonNegativeQuaternaryLabelDefault: 'redSolid500',
  buttonNegativeQuaternaryLabelHover: 'redSolid600',
  buttonNegativeQuaternaryLabelPressed: 'redSolid600',
  buttonNegativeQuaternaryLabelDisabled: 'redSolid100',
  buttonNegativeQuaternaryIconDefault: 'redSolid500',
  buttonNegativeQuaternaryStrokePressed: 'redSolid500',
  buttonNegativeQuaternaryIconHover: 'redSolid600',
  buttonNegativeQuaternaryIconPressed: 'redSolid600',
  buttonNegativeQuaternaryIconDisabled: 'redSolid100',
  buttonNegativeSecondaryIconDefault: 'redSolid500',
  buttonNegativeSecondaryIconPressed: 'redSolid500',
  buttonNegativeSecondaryIconHover: 'redSolid500',
  buttonNegativeSecondaryIconDisabled: 'redSolid100',
  buttonNegativeSecondaryLabelDefault: 'redSolid500',
  buttonNegativeSecondaryBgHover: 'redSolid100',
  buttonNegativeSecondaryStrokePressed: 'redSolid500',
  buttonNegativeSecondaryLabelHover: 'redSolid500',
  buttonNegativeSecondaryLabelPressed: 'redSolid500',
  buttonNegativeSecondaryLabelDisabled: 'redSolid100',
  buttonNegativeSecondaryBgPressed: 'redSolid100',
  buttonNegativeSecondaryBgDisabled: 'redSolid50',
  buttonNegativePrimaryStrokePressed: 'redSolid600',
  fieldRegularBgDefault: 'neutralWhiteTransparent0',
  fieldRegularBgHover: 'neutralWhiteTransparent0',
  fieldRegularBgPressed: 'neutralWhiteTransparent0',
  fieldRegularBgDisabled: 'neutralWhiteTransparent0',
  fieldRegularLabelDefault: 'neutralSolid500',
  fieldRegularLabelHover: 'neutralSolid500',
  fieldRegularLabelPressed: 'neutralSolid500',
  fieldRegularLabelFocusTyping: 'neutralSolid800',
  fieldRegularLabelDisabled: 'neutralBlackTransparent200',
  fieldRegularIconDefault: 'neutralSolid500',
  fieldRegularIconHover: 'neutralSolid500',
  fieldRegularIconPressed: 'neutralSolid500',
  fieldRegularIconFocusTyping: 'neutralSolid500',
  fieldRegularIconDisabled: 'neutralSolid400',
  fieldRegularBgFocusTyping: 'neutralWhiteTransparent0',
  fieldRegularBgTyped: 'neutralWhiteTransparent0',
  fieldRegularStrokeDefault: 'neutralSolid400',
  fieldRegularStrokeHover: 'primarySolid500',
  fieldRegularStrokePressed: 'primarySolid500',
  fieldRegularStrokeFocusTyping: 'primarySolid500',
  fieldRegularStrokeTyped: 'neutralSolid400',
  fieldRegularStrokeDisabled: 'neutralSolid300',
  fieldRegularLabelTyped: 'neutralSolid800',
  fieldRegularIconTyped: 'neutralSolid500',
  fieldNegativeStrokeDefault: 'redSolid500',
  fieldNegativeStrokeHover: 'redSolid600',
  fieldNegativeStrokePressed: 'redSolid600',
  fieldNegativeStrokeFocusTyping: 'redSolid500',
  fieldNegativeStrokeTyped: 'redSolid500',
  chipRegularBgDefault: 'neutralSolid300',
  chipRegularBgHover: 'neutralSolid400',
  chipRegularBgPressed: 'neutralSolid400',
  chipRegularBgFocus: 'neutralSolid300',
  chipRegularBgDisabled: 'neutralSolid300',
  chipRegularStrokeFocus: 'primarySolid500',
  chipRegularLabelDefault: 'primarySolid900',
  chipRegularLabelHover: 'primarySolid900',
  chipRegularLabelPressed: 'primarySolid900',
  chipRegularLabelFocus: 'primarySolid900',
  chipRegularLabelDisabled: 'neutralSolid400',
  chipRegularIconDefault: 'primarySolid900',
  chipRegularIconHover: 'primarySolid900',
  chipRegularIconPressed: 'primarySolid900',
  chipRegularIconFocus: 'primarySolid900',
  chipRegularIconDisabled: 'neutralSolid400',
  textParagraph: 'neutralBlackTransparent500',
  textCaption: 'neutralSolid500',
  textHeadingRegular: 'neutralSolid900',
  textHeadingHighlighted: 'neutralSolid1000',
  textLink: 'primarySolid600',
  textHeadingSubtle: 'neutralSolid700',
  rowBgDefault: 'neutralSolid0',
  rowBgHover: 'neutralSolid200',
  rowBgPressed: 'neutralSolid200',
  rowBgDisabled: 'neutralWhiteTransparent0',
  chipSelectedBgDefault: 'primarySolid50',
  chipSelectedBgHover: 'primarySolid100',
  chipSelectedBgPressed: 'primarySolid100',
  chipSelectedBgFocus: 'primarySolid50',
  chipSelectedBgDisabled: 'primarySolid50',
  chipSelectedStrokeFocus: 'primarySolid500',
  chipSelectedLabelDefault: 'primarySolid900',
  chipSelectedLabelHover: 'primarySolid900',
  chipSelectedLabelPressed: 'primarySolid900',
  chipSelectedLabelFocus: 'primarySolid900',
  chipSelectedLabelDisabled: 'neutralSolid400',
  chipSelectedIconDefault: 'neutralSolid700',
  chipSelectedIconHover: 'neutralSolid700',
  chipSelectedIconPressed: 'neutralSolid700',
  chipSelectedIconFocus: 'neutralSolid700',
  chipSelectedIconDisabled: 'neutralSolid400',
  bgDefault: 'neutralSolid0',
  progressElipseDefault: 'neutralSolid200',
  progressLineDefault: 'primarySolid500',
  progressLabelDefault: 'neutralSolid1000',
  progressLabelDisabled: 'neutralSolid400',
  progressLineDisabled: 'primarySolid200',
  progressElipseDisabled: 'neutralSolid200',
  buttonHighlightTerciaryBgDefault: 'neutralWhiteTransparent0',
  buttonHighlightTerciaryBgDisabled: 'neutralWhiteTransparent0',
  buttonHighlightQuaternaryBgHover: 'primarySolid50',
  buttonHighlightQuaternaryBgPressed: 'primarySolid50',
  buttonHighlightQuaternaryBgDisabled: 'neutralWhiteTransparent0',
  buttonSubtleTerciaryBgDefault: 'neutralWhiteTransparent0',
  buttonSubtleTerciaryBgDisabled: 'neutralWhiteTransparent0',
  buttonSubtleQuaternaryBgHover: 'neutralWhiteTransparent0',
  buttonSubtleQuaternaryBgPressed: 'neutralWhiteTransparent0',
  buttonSubtleQuaternaryBgDisabled: 'neutralWhiteTransparent0',
  buttonNegativeTerciaryBgDefault: 'neutralWhiteTransparent0',
  buttonNegativeTerciaryBgDisabled: 'neutralWhiteTransparent0',
  buttonNegativeQuaternaryBgHover: 'neutralWhiteTransparent0',
  buttonNegativeQuaternaryBgPressed: 'neutralWhiteTransparent0',
  buttonNegativeQuaternaryBgDisabled: 'neutralWhiteTransparent0',
  chipSelectedStrokeDefault: 'primarySolid500',
  chipSelectedStrokeHover: 'primarySolid500',
  chipSelectedStrokePressed: 'primarySolid500',
  chipSelectedNegativeBgDefault: 'redSolid50',
  chipSelectedNegativeBgHover: 'redSolid100',
  chipSelectedNegativeBgPressed: 'redSolid100',
  chipSelectedNegativeBgFocus: 'redSolid50',
  chipSelectedNegativeStrokeDefault: 'redSolid500',
  chipSelectedNegativeStrokeHover: 'redSolid500',
  chipSelectedNegativeStrokePressed: 'redSolid500',
  chipSelectedNegativeStrokeFocus: 'redSolid500',
  chipSelectedNegativeLabelDefault: 'primarySolid900',
  chipSelectedNegativeLabelHover: 'primarySolid900',
  chipSelectedNegativeLabelPressed: 'primarySolid900',
  chipSelectedNegativeLabelFocus: 'primarySolid900',
  chipSelectedNegativeIconDefault: 'neutralSolid700',
  chipSelectedNegativeIconHover: 'neutralSolid700',
  chipSelectedNegativeIconPressed: 'neutralSolid700',
  chipSelectedNegativeIconFocus: 'neutralSolid700',
  buttonNeutralPrimaryBgDefault: 'neutralSolid800',
  buttonNeutralPrimaryBgHover: 'neutralSolid700',
  buttonNeutralPrimaryBgPressed: 'neutralSolid700',
  buttonNeutralPrimaryBgDisabled: 'neutralSolid300',
  buttonNeutralPrimaryIconDefault: 'neutralSolid0',
  buttonNeutralPrimaryIconPressed: 'neutralSolid200',
  buttonNeutralPrimaryIconHover: 'neutralSolid0',
  buttonNeutralPrimaryIconDisabled: 'neutralSolid0',
  buttonNeutralPrimaryLabelDefault: 'neutralSolid0',
  buttonNeutralPrimaryLabelHover: 'neutralSolid0',
  buttonNeutralPrimaryLabelPressed: 'neutralSolid0',
  buttonNeutralPrimaryLabelDisabled: 'neutralSolid0',
  buttonNeutralPrimaryStrokePressed: 'neutralSolid900',
  buttonNeutralSecondaryBgDefault: 'neutralSolid200',
  buttonNeutralSecondaryBgHover: 'neutralSolid300',
  buttonNeutralSecondaryBgPressed: 'neutralSolid300',
  buttonNeutralSecondaryBgDisabled: 'neutralSolid200',
  buttonNeutralSecondaryIconDefault: 'neutralSolid700',
  buttonNeutralSecondaryIconPressed: 'neutralSolid700',
  buttonNeutralSecondaryIconHover: 'neutralSolid700',
  buttonNeutralSecondaryIconDisabled: 'neutralSolid400',
  buttonNeutralSecondaryLabelDefault: 'neutralSolid700',
  buttonNeutralSecondaryLabelHover: 'neutralSolid700',
  buttonNeutralSecondaryLabelPressed: 'neutralSolid700',
  buttonNeutralSecondaryLabelDisabled: 'neutralSolid400',
  buttonNeutralSecondaryStrokePressed: 'neutralSolid900',
  buttonNeutralTerciaryBgDefault: 'neutralWhiteTransparent0',
  buttonNeutralTerciaryBgHover: 'neutralSolid200',
  buttonNeutralTerciaryBgPressed: 'neutralSolid200',
  buttonNeutralTerciaryBgDisabled: 'neutralWhiteTransparent0',
  buttonNeutralTerciaryIconDefault: 'neutralSolid700',
  buttonNeutralTerciaryIconPressed: 'neutralSolid700',
  buttonNeutralTerciaryIconHover: 'neutralSolid700',
  buttonNeutralTerciaryIconDisabled: 'neutralSolid400',
  buttonNeutralTerciaryLabelDefault: 'neutralSolid700',
  buttonNeutralTerciaryLabelHover: 'neutralSolid700',
  buttonNeutralTerciaryLabelPressed: 'neutralSolid700',
  buttonNeutralTerciaryLabelDisabled: 'neutralSolid400',
  buttonNeutralTerciaryStrokeDefault: 'neutralSolid400',
  buttonNeutralTerciaryStrokeHover: 'neutralSolid400',
  buttonNeutralTerciaryStrokePressed: 'neutralSolid1000',
  buttonNeutralTerciaryStrokeDisabled: 'neutralSolid300',
  buttonNeutralQuaternaryBgDefault: 'neutralWhiteTransparent0',
  buttonNeutralQuaternaryBgHover: 'neutralSolid200',
  buttonNeutralQuaternaryBgPressed: 'neutralSolid200',
  buttonNeutralQuaternaryBgDisabled: 'neutralWhiteTransparent0',
  buttonNeutralQuaternaryLabelDefault: 'neutralSolid700',
  buttonNeutralQuaternaryLabelHover: 'neutralSolid700',
  buttonNeutralQuaternaryLabelPressed: 'neutralSolid700',
  buttonNeutralQuaternaryLabelDisabled: 'neutralSolid400',
  buttonNeutralQuaternaryIconDefault: 'neutralSolid700',
  buttonNeutralQuaternaryIconHover: 'neutralSolid700',
  buttonNeutralQuaternaryIconPressed: 'neutralSolid700',
  buttonNeutralQuaternaryIconDisabled: 'neutralSolid400',
  buttonNeutralQuaternaryStrokePressed: 'neutralSolid1000',
  shadowPressed: 'neutralBlackTransparent400',
  blackonwhite: 'neutralSolid1000',
  whiteonwhite: 'neutralSolid0',
  tabbaritemUnselected: 'neutralBlackTransparent500',
  tabbaritemSelected: 'primarySolid900',
  stroke: 'neutralSolid300',
  cardBg: 'neutralSolid200',
  modalShadow: 'neutralBlackTransparent500',
  modalStroke: 'neutralSolid700',
  toggleUnselectedBgActive: 'neutralSolid300',
  toggleSelectedBgActive: 'greenSolid500',
  toggleUnselectedBgDisabled: 'neutralSolid200',
  toggleSelectedBgDisabled: 'greenSolid50',
  toggleUnselectedControlActive: 'neutralSolid0',
  toggleUnselectedControlDisabled: 'neutralSolid0',
  toggleSelectedControlActive: 'neutralSolid0',
  toggleSelectedControlDisabled: 'neutralSolid0',
  chipSelectedStrokeDisabled: 'primarySolid200',
  bgDarker: 'neutralSolid200',
  headerShadow: 'neutralBlackTransparent50',
  chatbubbleShadow: 'neutralBlackTransparent50',
  sliderBgActive: 'neutralSolid300',
  sliderControlActive: 'primarySolid500',
  sliderControlStrokeUniversal: 'bgDefault',
  sliderFgActive: 'primarySolid500',
  sliderBgDisabled: 'neutralSolid300',
  sliderControlDisabled: 'primarySolid100',
  sliderFgDisabled: 'primarySolid100',
  fieldNegativeBgDefault: 'neutralWhiteTransparent0',
  fieldNegativeBgHover: 'neutralWhiteTransparent0',
  fieldNegativeBgPressed: 'neutralWhiteTransparent0',
  fieldNegativeBgFocusTyping: 'neutralWhiteTransparent0',
  fieldNegativeBgTyped: 'neutralWhiteTransparent0',
  fieldNegativeLabelDefault: 'redSolid500',
  fieldNegativeLabelHover: 'redSolid500',
  fieldNegativeLabelPressed: 'redSolid500',
  fieldNegativeLabelFocusTyping: 'neutralSolid800',
  fieldNegativeLabelTyped: 'neutralSolid800',
  fieldNegativeIconDefault: 'neutralSolid500',
  fieldNegativeIconHover: 'neutralSolid500',
  fieldNegativeIconPressed: 'neutralSolid500',
  fieldNegativeIconFocusTyping: 'neutralSolid500',
  fieldNegativeIconTyped: 'neutralSolid500',
  bgDefaultMedium: 'neutralSolid150',
  bgChat: 'neutralSolid0',
  bgDefault2: 'neutralSolid0',
}